<template>
  <div class="client-details">
    <portal to="sidebar-menu">
      <div>
        <nav-back-button to="/talent/resumes">
          {{$t('resume.details.menu.back')}}
        </nav-back-button>
        <div class="row">
          <div class="col-12">
            <nav-list :items="navigationItems"
                      @on-delete-click="deleteResume">
            </nav-list>
          </div>
        </div>
      </div>

    </portal>
    <router-view></router-view>
  </div>
</template>
<script>
  import get from 'lodash/get'
  import { mapMutations } from 'vuex'
  import { entities } from 'src/config/routeTypes'
  import NavList from 'src/components/List/NavList'
  import resumeModule from 'src/store/modules/resume'
  import ResumeService from 'src/services/ResumeService'

  export default {
    name: 'resume-details',
    components: {
      NavList
    },
    data () {
      return {
        error: null,
        deleteActive: false
      }
    },
    computed: {
      resume () {
        return this.$store.state.resume.currentResume || {}
      },
      navigationItems () {
        return [
          {
            name: this.$t('generic.general'),
            type: 'group'
          },
          {
            routeName: 'resume_dashboard',
            name: this.$t('generic.details')
          },
          {
            routeName: 'resume_edit',
            name: this.$t('generic.edit')
          },
          {
            name: this.$t('generic.delete.title')
          },
        ]
      }
    },
    methods: {
      get,
      ...mapMutations('resume', [resumeModule.types.SET_CURRENT_RESUME]),
      async deleteResume () {
        let id = this.$route.params.id
        await this.$confirm(this.$t('generic.delete.confirm', {title: id, entity: entities.RESUME}), {
          dangerouslyUseHTMLString: true
        })
        await ResumeService.delete(id)
        this.$router.go(-1)
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        let res = await ResumeService.getById(id, {
          with: 'candidate.candidate.user'
        })
        let resume = res.data
        if (resume) {
          next(vm => {
            vm[resumeModule.types.SET_CURRENT_RESUME](resume)
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    }
  }
</script>
<style lang="scss">
</style>
